export enum RoleEnum {
  ADMIN = 'ADMIN',
  STAFF = 'STAFF',
  CLIENT_MANAGER = 'CLIENT_MANAGER',
  PRODUCT_MANAGER = 'PRODUCT_MANAGER',
  TRADER = 'TRADER',
  TRADERS_OWNER = 'TRADERS_OWNER',
  MERCHANT = 'MERCHANT',
  GUEST = 'GUEST',
  USER = 'USER',
  SUPPORT = 'SUPPORT',
}
